import axios from "axios";
import baseUrl from "../../../../utilities/baseUrl";
import Swal from "sweetalert2";

const useServiceApi = async (
  shipment,
  needPrint,
  needSMS,
  index,
  collectingType = 1,
  needCollecting = true,
  internalSectionId
) => {
  const { newItem, SAddress, selectedService } = shipment;

  try {
    const token = localStorage.getItem("token");

    let weighttt = newItem.weight;

    if (selectedService.componyId === 3) {
      const chaparData = {
        addressId: SAddress.id,
        getterAddressId: newItem.getterAddress.id,
        methodRequest: selectedService.compony_type_post.chaparId,
        data: [newItem],
        needPrint,
        needSMS,
        index,
        collectingType,
        needCollecting,
        isBulk: true,
        internalSectionId,
        isCod: selectedService.isCod ? true : false,
      };

      const furl = baseUrl + "/internalpost/v1/chaparRate";

      const dataer = await axios.post(furl, chaparData, {
        headers: { Authorization: "Bearer " + token },
      });
      if (dataer.status === 200 && dataer.data.quote) {
        newItem.price = dataer.data.quote;
        newItem.totalPrice = dataer.data.totalPrice;
      }
    } else if (selectedService.componyId === 2) {
      const furl = baseUrl + "/internalpost/v1/mahexRate";

      const mahexData = {
        addressId: SAddress,
        getterAddressId: newItem.getterAddress,
        method: selectedService.compony_type_post.chaparId,
        value: newItem.cost,
        weight: weighttt,
        data: [newItem],
        isCod: false,
        needPrint,
        needSMS,
        index,
        collectingType,
        needCollecting,
        isBulk: true,
        internalSectionId,
      };

      const dataer = await axios.post(furl, mahexData, {
        headers: { Authorization: "Bearer " + token },
      });
      if (dataer.status === 200) {
        newItem.price = dataer.data.result.quote;
        newItem.totalPrice = dataer.data.result.totalPrice;
      }
    } else if (selectedService.componyId === 1) {
      const furl =
        baseUrl +
        "/internalpost/v1/postRate?postmethod=" +
        selectedService.componyTypeId;

      const postData = {
        addressId: SAddress,
        getterAddressId: newItem.getterAddress,
        method: selectedService.compony_type_post.chaparId,
        serviceTypeId: selectedService.compony_type_post.chaparId,
        value: newItem.cost,
        weight: weighttt,
        data: [newItem],
        methodPayment: isNaN(newItem.amountCOD) ? 1 : 0,
        needPrint,
        needSMS,
        index,
        collectingType,
        needCollecting,
        isBulk: true,
        internalSectionId,
        isCod: selectedService.isCod,
      };

      //disable post expess
      if (postData.serviceTypeId === 4) {
        throw new Error("پست اکسپرس غیر فعال است");
      }

      const dataer = await axios.post(furl, postData, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (dataer.status === 200 && dataer.data) {
        newItem.price = dataer.data.quote;
        newItem.totalPrice = dataer.data.totalPrice;
      }
    } else if (selectedService.componyId === 6) {
      const url = baseUrl + "/internalpost/v1/tipaxRate";

      const body = {
        senderAddressId: SAddress?.id,
        getterAddressId: newItem.getterAddress?.id,
        shipment: newItem,
        isCod: selectedService.isCod === 1,
        isBulk: true,
        needPrint,
        needSMS,
        index,
        collectingType,
        needCollecting,
        internalSectionId,
      };
      const response = await axios.post(url, body, {
        headers: { Authorization: "Bearer " + token },
      });
      if (response.status === 200) {
        newItem.price = response.data.result.quote;
        newItem.totalPrice = response.data.result.totalPrice;
      }
    } else if (selectedService.componyId === 7) {
      const url = baseUrl + "/internalpost/v1/avaPeymaRate";

      const body = {
        senderAddressId: SAddress?.id,
        getterAddressId: newItem.getterAddress?.id,
        shipment: newItem,
        isCod: selectedService.isCod === 1,
        isBulk: true,
      };
      const response = await axios.post(url, body, {
        headers: { Authorization: "Bearer " + token },
      });
      if (response.status === 200) {
        newItem.price = response.data.result.quote;
        newItem.totalPrice = response.data.result.totalPrice;
      }
    } else if (selectedService.componyId === 9) {
      const url = baseUrl + "/internalpost/v1/dekapostRate";
      const body = {
        companyTypeId: selectedService.componyTypeId,
        senderAddressId: SAddress?.id,
        getterAddressId: newItem.getterAddress?.id,
        isCod: selectedService.isCod === 1,
        needPrint,
        needSMS,
        internalSectionId,
        collectingType,
        needCollecting,
        parcels: [newItem],
      };

      const response = await axios.post(url, body, {
        headers: { Authorization: "Bearer " + token },
      });

      if (response && response.status === 200) {
        newItem.price = response.data.data.quote;
        newItem.totalPrice = response.data.data.totalPrice;
      }
    }

    return newItem;
  } catch (error) {
    if (error?.message && error?.message?.includes("undefined")) {
      Swal.fire({
        icon: "error",
        text: "خطای نامشخصی در سیستم رخ داد",
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }

    newItem.price = 0;
    return newItem;
  }
};

export default useServiceApi;
